module.exports = __webpack_public_path__ + "media/images/manifest/microbius-192-e423e1d602ba2baed8c06153c8ce6f4e.png";